import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

// eslint-disable-next-line import/no-named-as-default-member
export const i18n = i18next.use(initReactI18next);

void i18n.init({
  lng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  react: {
    useSuspense: false,
  },
});

i18n.services.formatter?.add('lowercase', (value: string) =>
  value.toLowerCase(),
);
